import { BRAND_COLORS, ERROR_COLORS, GRAY_COLORS, SHADOWS } from '../globalTheme';

export const theme = {
	button: {
		size: {
			xsmall: { width: '32px', height: '32px', padding: '6px' },
			small: { width: '36px', height: '36px', padding: '8px' },
			medium: { width: '40px', height: '40px', padding: '10px' },
			large: { width: '44px', height: '44px', padding: '12px' },
			xl: { width: '48px', height: '48px', padding: '14px' }
		},
		color: {
			primary: { backgroundColor: BRAND_COLORS.brand600, color: 'white' },
			secondary: {
				backgroundColor: BRAND_COLORS.brand50,
				color: BRAND_COLORS.brand700
			},
			error: { backgroundColor: ERROR_COLORS.error600, color: 'white' },
			destroy_secondary: {
				backgroundColor: ERROR_COLORS.error50,
				color: ERROR_COLORS.error700
			},
			bg_primary: {
				backgroundColor: BRAND_COLORS.brand50,
				color: BRAND_COLORS.brand700
			},
			transparent: {
				backgroundColor: 'transparent',
				color: BRAND_COLORS.brand700
			},
			gray: {
				backgroundColor: 'white',
				color: GRAY_COLORS.gray600
			}
		},
		iconButtonShadow: SHADOWS.xs,
		focused: {
			border: `1px solid ${BRAND_COLORS.brand300}`,
			boxShadow: `0px 0px 0px 4px ${BRAND_COLORS.brand100}`
		},
		destroyFocused: {
			boxShadow: `0px 0px 0px 4px ${ERROR_COLORS.error100}`
		},
		disabled: {
			backgroundColor: BRAND_COLORS.brand200
		},
		circle: {
			borderRadius: '100%'
		}
	}
};
export type Theme = typeof theme;
export type IconButtonSize = keyof Theme['button']['size'];
export type IconButtonColor = keyof Theme['button']['color'];
